import { AbstractGridStrategy } from './abstract.strategy';

export class HeightGridStrategy extends AbstractGridStrategy {
    protected stretchContent = false;

    constructor(height: number, strech: boolean = false) {
        super();
        this.gridHeight = height;
        this.stretchContent = strech;
    }

    public getGridHeight(): number {
        return this.gridHeight;
    }

    public getGridPageAmount(): number {
        let freeSpace = this.gridHeight;
        if (this.headerHeight) {
            freeSpace -= this.headerHeight;
        }
        return Math.floor(freeSpace / this.a9GridConstants.dataRowHeight);
    }

    public showPagination() {
        return true;
    }

    public isStretchable() {
        return this.stretchContent;
    }
    public detach() {}
    public setGridElement(gridElement: HTMLElement): void {}
}
